// Phase 2 stub engine. Its only job is to prove the input → worker → back
// round-trip and exercise the payload shape without blocking the UI. It does
// NOT implement real diffing — the actual engine and the locked compare()
// contract { added, removed, modified, unchanged, changes } arrive in Phase 3.
// Runs identically on the worker thread and the main-thread fallback.
export function runCompare(payload) {
  const { left = '', right = '', format = 'text' } = payload || {};
  const l = splitLines(left);
  const r = splitLines(right);

  // Naïve, order-insensitive line delta — enough to return something real,
  // clearly marked `stub` so it is never mistaken for the semantic engine.
  const leftSet = new Set(l);
  const rightSet = new Set(r);
  const addedLines = r.filter((line) => !leftSet.has(line)).length;
  const removedLines = l.filter((line) => !rightSet.has(line)).length;

  return {
    stub: true,
    format,
    leftLines: l.length,
    rightLines: r.length,
    leftBytes: byteLength(left),
    rightBytes: byteLength(right),
    addedLines,
    removedLines,
    identical: left === right,
  };
}

function splitLines(s) {
  return s.length ? s.split(/\r?\n/) : [];
}

function byteLength(s) {
  // TextEncoder exists in browsers, workers, and Node 18+.
  return new TextEncoder().encode(s).length;
}
